import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

const StackedBarChart = ({ showAnnotation = false, graphData = [], activeTab = "COF" }) => {
    const categories = useMemo(() =>
        graphData.map(item => item.Network || 'Unknown'),
        [graphData]
    );

    const actualCOFData = useMemo(() =>
        graphData.map(item => parseFloat((item.Actual_COF || 0).toFixed(2))),
        [graphData]
    );

    const cofIncreaseData = useMemo(() =>
        graphData.map(item => parseFloat((item.COF_Increase || 0).toFixed(2))),
        [graphData]
    );

    const data1 = {
        categories,
        series: [
            { name: 'Original COF', data: actualCOFData },
            { name: 'COF Improved', data: cofIncreaseData } //check
        ]
    };

    const columnWidth = (() => {
        const length = data1.categories.length;
        if (length === 1) { return '2%'; }
        if (length === 2) { return '5%'; }
        if (length === 3) { return '8%'; }
        return '10%';
    })();

    const options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: { show: false }
        },
        colors: ['#ed8ec9', '#a6de57'],
        grid: { show: false },
        dataLabels: { enabled: false },
        annotations: {
            yaxis: showAnnotation ? [{
                y: 95,
                borderColor: '#B0B0B0',
                strokeDashArray: [5, 5],
                label: {
                    borderColor: '#B0B0B0',
                    style: {
                        color: '#B0B0B0',
                        padding: '20px',
                        fontSize: '10px',
                    },
                    text: 'Target = 95%',
                }
            }] : []
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth,
                borderRadius: 10,
            }
        },
        stroke: { width: 0 },
        yaxis: {
            labels: {
                formatter: value => `${value}%`,
            },
            title: {
                text: 'Fulfillment %',
                style: {
                    fontSize: '12px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 500,
                    color: "#333"
                }

            },
            min: activeTab === "COF" ? 0 : undefined,
        },
        xaxis: {
            categories: data1.categories,
            axisBorder: { offsetY: activeTab === "COF" ? 3 : 0 },
        },
        tooltip: {
            shared: true, // Enables shared tooltip for multiple series
            intersect: false, // Must be false when shared is true
            y: {
                formatter: (_value, { seriesIndex, dataPointIndex, w }) => {
                    if (!w || !w.globals || !w.globals.series) {
                        return 'No data';
                    }
                    const seriesValue = w.globals.series[seriesIndex]?.[dataPointIndex] ?? 0;
                    return `<div>${seriesValue.toFixed(2)}%</div>`;
                },
            },
        },
        fill: { opacity: 1 },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            markers: {
                width: 12,
                height: 12,
                radius: 10,
            },
        }
    };

    return (
        <div className="stacked-bar-chart">
            <ReactApexChart options={options} series={data1.series} type="bar" height={350} />
        </div>
    );
};

export default StackedBarChart;
